import CacheService from '../cache-service';
const axios = require('axios');

class HomePageService extends CacheService {
  getData(id) {
    return this.getCachedData(`/api/home`);
  }
}

const homePageService = new HomePageService();

export default homePageService;